var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"centertitle",style:({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '18px',
      lineHeight: '1.5',
      color: '#ffffff',
      textAlign: 'center',
      textShadow: false ? '0px 0px 14px rgba(15, 146, 255,1)' : '',
    }),attrs:{"id":"item1550b630-3dec-11ec-a2e6-953464dcce14"}},[_c('p',[_vm._v("求职数据统计（近五个月）")])]),_vm._m(0),_c('div',{attrs:{"id":"item0c892655-9dbb-497c-bec9-239cca87c34a"}},[_c('img',{style:({ width: '100%', height: '100%' }),attrs:{"src":require("../../../assets/images/线框.png"),"alt":""}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"leftCentershowWindow2"}},[_c('div',{staticClass:"innerBox"},[_c('div',{attrs:{"id":"leftCenterEchartsBox21"}}),_c('div',{attrs:{"id":"leftCenterEchartsBox22"}}),_c('div',{attrs:{"id":"leftCenterEchartsBox23"}})])])
}]

export { render, staticRenderFns }